import { Injectable, Optional } from '@angular/core';

import type { StateSaver } from '../../../lib/store-persist/state-storage.model';
import { IBetslipState } from '../../base/store/state';
import { BetslipOverAskStateStorageService } from '../over-ask/services/betslip-over-ask-state-storage';
import BetslipPicksStateStorageService from '../picks/services/betslip-picks-state-storage.service';
import { BetslipQuickBetStateStorageService } from '../quick-bet/betslip-quick-bet-state-storage.service';
import { IQuickBetSaveState } from '../quick-bet/quick-bet.state';
import ResultStateStorageService from '../result/services/result-state-storage.service';
import SettingsStateStorageService from '../settings/services/settings-state-storage.service';
import BetslipTypesStateStorageService from '../types/services/betslip-types-state-storage.service';
import { IBetslipSavedState } from './betslip-state-model';

@Injectable()
export default class BetslipStateSaverService implements StateSaver<IBetslipState, any> {
    constructor(
        private picksStateStorage: BetslipPicksStateStorageService,
        private typeStateStorage: BetslipTypesStateStorageService,
        private resultStateStorage: ResultStateStorageService,
        private settingsStateStorage: SettingsStateStorageService,
        private overAskStateStorage: BetslipOverAskStateStorageService,
        @Optional() private quickBetStateStorage: BetslipQuickBetStateStorageService | null,
    ) {}

    save(state: IBetslipState): IBetslipSavedState {
        const baseState = { ...state.base, isBetslipKeypadOpened: false };

        return {
            base: baseState,
            picks: this.picksStateStorage.toSavedState(state.picks),
            types: this.typeStateStorage.toSavedState(state.types),
            rewardTokens: state.rewardTokens,
            placeBet: state.placeBet,
            // placeBet: this.placeBetStateStorage.toSavedState(state.placeBet),
            result: this.resultStateStorage.toSavedState(state.result),
            settings: this.settingsStateStorage.toSavedState(state.settings),
            placeButton: state.placeButton,
            overAskState: this.overAskStateStorage.toSavedState(state.overAskState),
            quickBet: this.quickBetStateStorage?.toSavedState(state.quickBet) || ({} as never as IQuickBetSaveState),
            oddsPreferencePopupState: state.oddsPreferencePopupState,
            hiddenMarket: state.hiddenMarket,
        };
    }
}
